import axios from "axios";
export default {
  namespaced: true,
  state: {
    invoices: [],
    all_invoices: [],
    paid_invoices: [],
    paid_invoices_pagination: {
      current_page: 1,
      last_page: 1,
      total: 0,
      per_page: 15,
    },
    unpaid_invoices: [],
    deleted_invoices: [],
  },
  getters: {
    invoices(state) {
      return state.invoices;
    },
    all_invoices(state) {
      return state.all_invoices;
    },
    paid_invoices(state) {
      return state.paid_invoices;
    },
    paid_invoices_pagination(state) {
      return state.paid_invoices_pagination;
    },
    unpaid_invoices(state) {
      return state.unpaid_invoices;
    },
    deleted_invoices(state) {
      return state.deleted_invoices;
    },
  },
  mutations: {
    SET_ALL_INVOICES(state, all_invoices) {
      state.all_invoices = all_invoices;
    },
    SET_PAID_INVOICES(state, response) {
      state.paid_invoices = response.data;
      state.paid_invoices_pagination = {
        current_page: response.current_page,
        last_page: response.last_page,
        total: response.total,
        per_page: response.per_page,
      };
    },

    SET_INVOICES(state, invoices) {
      state.invoices = invoices;
    },
    ADD_INVOICE(state, invoice) {
      if (invoice.is_invoice == 1) {
        state.all_invoices.unshift(invoice);
      }
    },
    EDIT_INVOICE(state, invoice) {
      var index = state.all_invoices.findIndex((a) => a.id == invoice.id);
      state.all_invoices.splice(index, 1, invoice);
    },
    DELETE_INVOICE(state, request) {
      if (request.is_invoice == 1) {
        const filtered = state.all_invoices.filter((i) => {
          return i.id != request.id;
        });
        state.all_invoices = filtered;
      }
    },
    SET_UNPAID_INVOICES(state, unpaid_invoices) {
      state.unpaid_invoices = unpaid_invoices;
    },
    DELETE_INVOICE_ITEM(state, request) {
      const { payable_id, invoice_id, is_quote } = request;
      const invoice = state.invoices.find(
        (invoice) => invoice.id == invoice_id
      );
      if (invoice) {
        const payables = is_quote ? invoice.quoteables : invoice.payables;
        const index = payables.findIndex((payable) => payable.id == payable_id);
        if (index !== -1) {
          payables.splice(index, 1);
        }
      }
    },
    SET_DELETED_INVOICES(state, deleted_invoices) {
      state.deleted_invoices = deleted_invoices;
    },
    REMOVE_DELETED_INVOICE(state, id) {
      state.deleted_invoices = state.deleted_invoices.filter((i) => i.id != id);
    },
  },
  actions: {
    // get deleted invoices
    async get_deleted_invoices({ commit }) {
      let response = await axios.get("/deleted_invoices");
      commit("SET_DELETED_INVOICES", response.data);
    },

    async get_all_invoices({ commit }) {
      let response = await axios.get("/all_invoices");
      commit("SET_ALL_INVOICES", response.data);
    },
    async get_invoice_detail(_, id) {
      let response = await axios.get("/invoice_detail/" + id);
      return response.data;
    },
    async get_paid_invoices({ commit }, params = {}) {
      const {
        page = 1,
        per_page = 15,
        search = "",
        sort_by = "id",
        sort_dir = "desc",
        month = "",
        week = "",
      } = params;
      let response = await axios.get("/paid_invoices", {
        params: { page, per_page, search, sort_by, sort_dir, month, week },
      });
      commit("SET_PAID_INVOICES", response.data);
    },
    async get_paid_invoice_detail(_, id) {
      let response = await axios.get("/paid_invoice/" + id);
      return response.data;
    },
    async get_unpaid_invoices({ commit }) {
      let response = await axios.get("/unpaid_invoices");
      commit("SET_UNPAID_INVOICES", response.data);
    },
    async get_invoices({ commit }, customer_id) {
      let response = await axios.get("/invoices/" + customer_id);
      commit("SET_INVOICES", response.data);
    },
    async add_invoice({ commit }, request) {
      let response = await axios.post("/invoice", request);
      commit("ADD_INVOICE", response.data);
    },
    async edit_invoice({ commit }, request) {
      commit("EDIT_INVOICE", request);
    },
    async delete_invoice({ commit }, request) {
      var id = request.id;
      // Paid / partially-paid invoices may have already been delivered. Ask whether the
      // goods physically came back before returning them to stock. Fully unpaid invoices
      // are cancellations and restore automatically (the backend handles that).
      const needsAsk =
        request.invoice_status &&
        request.invoice_status !== "Waiting for Payment";
      let restore_stock = false;
      if (needsAsk) {
        restore_stock = window.confirm(
          "This invoice is already paid/partially paid.\n\n" +
            "Did these item(s) physically come back to your stock?\n\n" +
            "OK = Yes, return them to stock\n" +
            "Cancel = No, they stayed with the customer (keep stock as sold)"
        );
      }
      await axios.delete("/invoice/" + id, {
        params: { restore_stock: restore_stock ? 1 : 0 },
      });
      commit("DELETE_INVOICE", request);
    },
    // Revert a soft-deleted invoice: restores the invoice + payments, reverses
    // the deletion's journal entries, and re-deducts item stock (FIFO).
    async restore_invoice({ commit }, request) {
      var id = request.id;
      let response = await axios.put("/invoice/" + id + "/restore", null, {
        params: { rededuct_stock: request.rededuct_stock ? 1 : 0 },
      });
      commit("REMOVE_DELETED_INVOICE", id);
      return response.data;
    },
    async add_item_to_invoice_items({ commit }, request) {
      let response = await axios.post("/add_item_to_invoice_items", request);
      commit("EDIT_INVOICE", response.data);
      return response.data;
    },
    async add_service_to_invoice_items({ commit }, request) {
      let response = await axios.post("/add_service_to_invoice_items", request);
      commit("EDIT_INVOICE", response.data);
      return response.data;
    },
    async delete_invoice_item({ commit }, invoice_item_id) {
      let response = await axios.delete(
        "/delete_invoice_item/" + invoice_item_id
      );
      if (response.data && response.data.id) {
        commit("EDIT_INVOICE", response.data);
      }
      return response.data;
    },
    async update_invoice_item_price({ commit }, { invoice_item_id, payload }) {
      let response = await axios.put(
        "/update_invoice_item_price/" + invoice_item_id,
        payload
      );
      if (response.data && response.data.id) {
        commit("EDIT_INVOICE", response.data);
      }
      return response.data;
    },
  },
};
